import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import PosMenu from '../components/Menu/posMenuTab/PosMenu';
import LowStockBanner from '../features/inventory/LowStockBanner';
import PageHeader from '../components/layout/PageHeader';

/** Products catalog (made / whole) — previously Inventory → Products tab */
export default function Menu({ reload }) {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <PageHeader
        title="Products"
        subtitle="Catalog items, recipes, and sellable inventory"
      />
      <LowStockBanner
        onView={() => navigate('/inventory/raw-ingredients', { state: { focusLowStock: true } })}
      />
      <Box sx={{ flex: 1, px: { xs: 1, md: 2 }, pt: 1.5, pb: 3 }}>
        <PosMenu reload={reload} />
      </Box>
    </Box>
  );
}
